import type * as ecModels from '../../../models'
import * as plugin from '../../plugin'

import { getActionsConfig } from './actions'
import { Config } from './config'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Used to manage the process of editing entities before submitting them for
 * mutations (i.e. creation, update, or deletion)
 */
export class Plugin<
  TTypeParams extends ecModels.TypeParams.Constraint,
> extends plugin.Plugin<
  TTypeParams,
  plugin.Plugin.Id.Standard.Editing,
  State<TTypeParams>,
  Selectors<TTypeParams>,
  ReturnType<typeof getActionsConfig<TTypeParams>>
> {
  /**
   * @see {@link Config}
   */
  public readonly config: Readonly<Config<TTypeParams>>

  constructor({ collection, config }: Plugin.constructor.Params<TTypeParams>) {
    const finalConfig = Config.from(config)
    super({
      actions: getActionsConfig<TTypeParams>(collection, finalConfig),
      collection,
      id: plugin.Plugin.Id.Standard.Editing,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })
    this.config = finalConfig
    this.feature.registerEffects(
      effects.setCurrentEdit(collection),
      effects.unsetCurrentEntityWhenDoneEditing(collection),
      effects.submitEdits(this),
      effects.discardEdits(this),
    )
  }
}
export namespace Plugin {
  export namespace constructor {
    export type Params<TTypeParams extends ecModels.TypeParams.Constraint> =
      Pick<plugin.Plugin.Default<TTypeParams>, 'collection'> & {
        config?: Config.Options<TTypeParams>
      }
  }
}
